module.exports = __webpack_public_path__ + "static/media/md-fitness.b22471b4.svg";